import clsx from "clsx"

import { headingElements } from "./config"
import type { TitleProps } from "./types"

type SubtitleProps = Pick<TitleProps, "className" | "children" | "level" | "testId">

/**
 * This component is only part of the Marketing Design System typography.
 * Do not use in Expo apps.
 */
export const Subtitle = ({ children, className, level, testId }: SubtitleProps) => {
  const H = level ? headingElements[level] : "p"

  return (
    <H
      data-testid={testId ?? "subtitle"}
      className={clsx("font-sans font-normal", "text-[1.375rem] lg:text-[1.625rem]", "leading-tight", className)}>
      {children}
    </H>
  )
}
